module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.id
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c3ca432"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-frappe-chart/src/components/Chart.vue
// module id = 1657
// module chunks = 0